<script>
    import Footer from '../landing_page/footer.svelte';
    import FaqSection from './faq_section.svelte';
    import ForSection from './for_section.svelte';
    import HeaderProgramSection from './header_program_section.svelte';
    import FaqMbl from './mobile_reuse-section/faq_mbl.svelte';
    import SliderLeftMbl from './mobile_reuse-section/slider_left_mbl.svelte';
    import SliderRightMbl from './mobile_reuse-section/slider_right_mbl.svelte';
    const {title} = rpcjs.props;
    title.set('Global | Government');
    import {
        globalPage,
        globalForSection,
        faqGlobal,
        sliderFromLeft,
        sliderHeroTraining,
    } from './program_data.js';
    import {
        sliderRightMbl,
        sliderLeftMbl,
    } from './mobile_reuse-section/mobile_reuse_section_data.js';
    import SliderFromLeft from './slider_from_left.svelte';
    import SliderFromRight from './slider_from_right.svelte';
    const list = [
        {
            description:
                'Develop technology, innovation and investment ecosystem ',
            i: 'i',
        },
        {
            description: 'Reach your Sustainable Development Goals.',
            i: 'ii',
        },
        {
            description:
                'Provide entrepreneurial education and create more job opportunities.',
            i: 'iii',
        },
        {
            description:
                'Build a bridge to Silicon Valley - the most innovative place in the world.',
            i: 'iv',
        },
        {
            description:
                'Attract global investment for your national startups.',
            i: 'v',
        },
        {
            description:
                'Solve national issues in clean energy, health tech, '+
                'gender equality, agriculture, manufacturing, climate action and economic growth',
            i: 'vi',
        },
    ];
    const program = [
        {
            Program_heading: [
                {point: 'Global Policy makers '},
                {point: 'Investors'},
                {point: 'Youth Leaders'},
            ],
        },
        {
            Program_heading: [
                {point: 'Pre-Seed Startups'},
                {point: 'Growth Stage Startups'},
                {point: 'Universities'},
            ],
        },
        {
            Program_heading: [{point: 'National Innovation Institutions'}],
        },
    ];
    const pointsMbl = [
        {
            description: 'Global Policy makers',
        },
        {
            description: 'Investors',
        },
        {
            description: 'Youth Leaders',
        },
        {
            description: 'Pre-Seed Startups',
        },
        {
            description: 'Growth Stage Startups',
        },
        {
            description: 'Universities',
        },
        {
            description: 'National Innovation <br> Institutions',
        },
    ];
    const benefits = [
        {
            bg_color: '#36a1bf',
            text: 'Investement Advisory to Support National Ecosystem',
            top: '4.96vw 3vw',
        },
        {
            bg_color: '#0072FF',
            text: 'Capacity Building and Training',
            top: '4.96vw 3vw',
        },
        {
            bg_color: '#384AC9',
            text: 'Membership to the Largest Global Ecosystem Skyrocketing Talent, Oppertuninties and Capital',
            top: '2.976vw 3.65vw',
        },
    ];
    const benefits2 = [
        {
            bg_color: '#2C71CE',
            text: 'Entrepreneurial Education Programs',
            top: '4.96vw 3vw',
        },
        {
            bg_color: '#15248E',
            text: 'Investement Advisory to Support National Ecosystem',
            top: '4.96vw 3vw',
        },
    ];
    const benefitsMbl = [
        {
            bg_color: '#36a1bf',
            text: 'Investement Advisory to Support National Ecosystem',
        },
        {
            bg_color: '#0072FF',
            text: 'Capacity Building and Training',
        },
        {
            bg_color: '#384AC9',
            text: 'Membership to the Largest Global Ecosystem Skyrocketing Talent, Oppertuninties and Capital',
        },
        {
            bg_color: '#2C71CE',
            text: 'Entrepreneurial Education Programs',
        },
        {
            bg_color: '#15248E',
            text: 'Investement Advisory to Support National Ecosystem',
        },
    ];
    const processText = [
        {
            text: 'Entrepreneurship and technology hubs in universities',
        },
        {
            text: 'National business plan competitions',
        },
        {
            text: 'Future skill-set development training programs Acceleration for startups from ideation to growth stage',
        },
        {
            text: 'Funding for most scalable Ideas',
        },
    ];
    const curriculum = [
        {
            img: '/images/global_section/curriculum_icons/icon2.svg',
            width: '8.995vw',
            mbl_width: '22.400vw',
            padding: '3vw 0.5vw',
            left: '2vw',
            description:
                'Our learning solutions help develop the future ready skills,'+
                ' latest market and technology insight and innovative solution-oriented '+
                'mindset.Our curriculum focuses on hands-on and experiential learning. All'+
                ' our instructors are highly experienced entrepreneurs who have built, pivoted'+
                ' and scaled their own companies. Each individual who attends the program goes through '+
                'a transformative experience, gets maximum exposure and becomes part of a powerful lifelong network.',
        },
        {
            img: '/images/global_section/curriculum_icons/icon1.svg',
            width: '4.552vw',
            mbl_width: '11.848vw',
            padding: '4.5vw 0.5vw',
            left: '4.5vw',
            description:
                'All our mentoring sessions are customized according to each individuals need, their strengths,'+
                ' and their industry specific startup needs. Throughout the  journey entrepreneurs  are inspired,'+
                ' supported and mentored by subject matter experts, investors, entrepreneurs and innovators.',
        },
    ];
    const user = {view_all: false};
    /**
     *
     */
    function toggle() {
        user.view_all = !user.view_all;
    }
    const usermbl = {view_all_mbl: false};
    /**
     *
     */
    function toggleMbl() {
        usermbl.view_all_mbl = !usermbl.view_all_mbl;
    }
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <HeaderProgramSection
        data={globalPage}
        lineHeight="12.630vw"
        lineHeightMbl="11.111vw"
        TopMbl="97vw"
        check={false}
        colors="white"
        MargintopMbl="25vw"
        hrTop="-2vw"
        headingTop="-8vw"
        headingLeft="-0.063vw"
        hrWidth="72.929vw"
        wordSpace="0.3vw"
        textWidth="68.698vw"
        textWidthMbl="85.834vw"
        discTop="35.5vw"
    />
    <div style="margin-top: 5.362vw;">
        <ForSection
            data={globalForSection}
            marginFor="-8.5vw"
            headingTop="15.75vw"
            rightMargin="2.778vw"
            headingLeft="7.4vw"
        />
    </div>

    <div class="desktop">
        <div
            style="background: linear-gradient(1.05deg, rgb(0, 32, 75) 25.19%, rgb(0, 66, 155) 99.35%);
            margin-top: 14.455vw;
            padding: 1vw;"
        >
            <div style="width: 88.815vw;margin:7vw auto;padding:0 1vw;">
                <div style="display: flex;align-items:center">
                    <h1
                        style="color:white;font-size:1.191vw;margin-right:5vw;opacity: 0.7;"
                    >
                        02
                    </h1>
                    <h1
                        style="color:white;font-size:2.068vw;text-transform: uppercase;"
                    >
                        Why Join This Program
                    </h1>
                </div>
                <div
                    style="display:flex;justify-content:space-between;margin-top: 5vw;"
                >
                    <div
                        style="    width: 26.886vw;
                        
                        margin-left: 7vw;
                        border-radius: 30vw;"
                    >
                        <img
                            src="/images/global_section/why_this_program_image.png"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div
                        style=" width: 40vw;
                        margin-top: -0.7vw;
                        line-height: 2.315vw;
                    "
                    >
                        {#each list as data}
                            <div style="display: flex;">
                                <div
                                    style="padding-top: 0.7vw;    width: 2vw;
                                text-align: end;"
                                >
                                    <p class="footer-count">{data.i}</p>
                                </div>
                                <div
                                    style="margin-left: 3.5vw;margin-bottom: 1vw"
                                >
                                    <p class="footer-text">
                                        {data.description}
                                    </p>
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
                <div style="text-align: center; margin-top:3vw;">
                    <button
                        on:click={() => (location.href = '/applyProgram')}
                        style="width: 15.619vw;height:3.905vw;border-radius:1.985vw;border:none;background-color:#F7E05F;font-size:1.191vw;"
                        >Apply</button
                    >
                </div>
            </div>
        </div>
        <div style="position: relative;">
            <div style="position: relative; margin-top: -4.3vw;">
                <div class="circle" />
                <div class="circle" />
                <div class="circle" />
            </div>
            <div
                style="position: relative; display: flex;align-items:center; margin-left:5.291vw; margin-top:10vw; "
            >
                <h1
                    class="section1"
                    style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3;    margin-top: 0.6vw;"
                >
                    03
                </h1>
                <div>
                    <h1
                        class="section-title"
                        style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                    >
                        Who else will be in this program or who will we target
                        for this program
                    </h1>
                </div>
            </div>
            <ul
                style="display: flex;
        justify-content: space-between;
        list-style: none;
        width: 75vw;
        margin-left: 13vw;
        margin-top:5.2vw;"
            >
                {#each program as data}
                    <li>
                        <ul style="list-style-type: disc;">
                            {#each data.Program_heading as data}
                                <li>
                                    <p
                                        style="width: 15.153vw;
                                        font-size: 1.323vw;
                                        line-height: 1.601vw;color:#00204B;margin-bottom: 1.786vw;"
                                    >
                                        {data.point}
                                    </p>
                                </li>
                            {/each}
                        </ul>
                    </li>
                {/each}
            </ul>
            <div
                style="    position: relative;
                display: flex;
                align-items: center;
                margin-left: 5.291vw;
                margin-top: 9vw; "
            >
                <h1
                    class="section1"
                    style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3;    margin-top: 0.65vw;"
                >
                    04
                </h1>
                <div>
                    <h1
                        class="section-title"
                        style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                    >
                        Benefits of this Program
                    </h1>
                </div>
            </div>
            <div style="display: flex;">
                <div
                    style="width: 22.090vw; margin-top:9.061vw;margin-left:9.854vw;"
                >
                    <img
                        src="/images/global_section/benefits_program_image.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div style="display: flex;">
                    <div style="margin-left: 4vw; margin-top: 3vw;">
                        {#each benefits as data}
                            <div
                                class="invesment-div"
                                style="background-color: {data.bg_color};"
                            >
                                <hr class="hr-css" />
                                <p
                                    style="font-size: 1.455vw;
                                    font-weight: 600;
                                    padding: {data.top};
                                    color: white; "
                                >
                                    {data.text}
                                </p>
                            </div>
                        {/each}
                    </div>
                    <div style="margin-left: 1vw;margin-top: 11.442vw;">
                        {#each benefits2 as data}
                            <div
                                class="invesment-div"
                                style="background-color: {data.bg_color};"
                            >
                                <hr class="hr-css" />
                                <p
                                    style="font-size: 1.455vw;
                                    font-weight: 600;
                                    padding: {data.top};
                                    color: white; "
                                >
                                    {data.text}
                                </p>
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
        <div
            style="position: relative; display: flex;align-items:center; margin-left:4vw; margin-top:10vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3;    margin-top: 0.65vw;"
            >
                05
            </h1>
            <div>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                >
                    Application or Custom Design Process
                </h1>
            </div>
        </div>
        <div class="process-div">
            <h4
                style="font-size:1.323vw; font-weight:600; color: rgba(0, 32, 75, 1);padding: 2vw 3vw;"
            >
                Process
            </h4>
            <ul class="points">
                {#each processText as data}
                    <li style="">
                        <p
                            style="    width: 34vw;
                            padding-left: 1.116vw;
                            font-size: 1.19vw;
                            line-height: 1.440vw;
                            color: rgba(0, 32, 75, 1);"
                        >
                            {data.text}
                        </p>
                    </li>
                {/each}
            </ul>
        </div>
        <div
            style="position: relative; display: flex;align-items:center; margin-left:4vw; margin-top:8vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3;"
            >
                06
            </h1>
            <div>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:2.068vw;"
                >
                    FAQs
                </h1>
            </div>
        </div>
        <div
            class={user.view_all ? 'view-all' : 'view-less'}
            style="overflow: hidden; margin-top:1vw"
        >
            <FaqSection detail={faqGlobal} />
        </div>

        {#if !user.view_all}
            <button class="view-all-btn " on:click={toggle}>
                <p class="view-text ">Load More</p>
                <div style="width: 0.5vw;margin-left: 0.8vw;">
                    <img
                        src="images/global_section/arrow.svg"
                        alt=""
                        width="100%"
                    />
                </div>
            </button>
        {/if}
        {#if user.view_all}
            <button class="view-all-btn  " on:click={toggle}>
                <p class="view-text ">Load Less</p>
                <div
                    style="width: 0.5vw;margin-left: 0.8vw;transform: rotate(180deg);"
                >
                    <img
                        src="images/global_section/arrow.svg"
                        alt=""
                        width="100%"
                    />
                </div>
            </button>
        {/if}
        <div
            style="position: relative; display: flex;align-items:center; margin-left:4vw; margin-top:10vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3;
                margin-top: 0.65vw;"
            >
                07
            </h1>
            <div>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                >
                    GLOBAL PARTNERS
                </h1>
            </div>
        </div>
        <SliderFromRight data={sliderHeroTraining} />
        <SliderFromLeft data={sliderFromLeft} />
        <div
            style="position: relative; display: flex;align-items:center; margin-left:4vw; margin-top:17vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3;margin-top:0.65vw;"
            >
                08
            </h1>
            <div>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                >
                    Curriculum Highlights
                </h1>
            </div>
        </div>
        <div
            style="border-radius:1.2vw;box-shadow: 0vw 0.265vw 2.912vw rgba(0, 32, 75, 0.2);width: 88.757vw;
        margin: 5.158vw auto;"
        >
            {#each curriculum as data}
                <div class="content-holder">
                    <div
                        style="display: inline-flex;align-items: flex-end;padding:{data.padding};"
                    >
                        <div
                            class="img-wrraper-logo"
                            style="width: 7.5vw;margin: auto; padding-left:{data.left}"
                        >
                            <img
                                style=" width:{data.width}"
                                src={data.img}
                                alt=""
                                width="100%"
                            />
                        </div>
                        <div>
                            <h1
                                class="section1list"
                                style="font-size: 1.190vw;width: 63.75vw;
                                color:rgba(0, 32, 75, 1);
                        margin-left: 9.5vw;"
                            >
                                {data.description}
                            </h1>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
        <div>
            <div
                style="position: relative; display: flex;align-items:center; margin-left:4vw; "
            >
                <h1
                    class="section1"
                    style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3;    margin-top: -2.3vw;"
                >
                    09
                </h1>
                <div style="margin-top:7vw;">
                    <h1
                        class="section-title"
                        style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                    >
                        PARTNER HIGHLIGHTS
                    </h1>
                    <p
                        style="font-size: 1.058vw;
                width: 40.18vw;
                color: rgb(0, 32, 75);
                margin-top: 1.587vw;
                text-align: justify;"
                    >
                        Our alumni hail from 101 countries and we work with
                        numerous government policy makers, ministries and
                        institutional partners in developing ecosystems. We
                        collaborate to work towards building entrepreneurship
                        support systems, job creation, empowering youth and
                        building foundations for future technology. All our
                        partnerships focus on building sustainable, scalable and
                        long term impact.
                    </p>
                </div>
            </div>
            <div
                style="
        margin-left: 17.923vw;
        width: 64.208vw;
        margin-top: 5.688vw;
    "
            >
                <img
                    width="100%"
                    src="images/global_section/partners.svg"
                    alt=""
                />
            </div>
        </div>
    </div>
    <div class="mobile">
        <div
            style="background: linear-gradient(1.05deg, #00204B 50.19%, #00429B 99.35%);padding:7vw; margin-top: 20vw;"
        >
            <div style="display: flex;align-items:center">
                <h1
                    style="color:white;font-size:2.778vw;margin-right:5.833vw;opacity: 0.7;"
                >
                    02
                </h1>
                <h1
                    style="color:white;font-size:5.556vw;text-transform: uppercase;"
                >
                    Why Join This Program
                </h1>
            </div>
            <div style="width:75.833vw;margin:5vw auto;border-radius: 30vw;">
                <img
                    src="/images/global_section/why_mobile.png"
                    alt=""
                    width="100%"
                />
            </div>
            <div style="  margin-top: 8.834vw;">
                {#each list as data}
                    <div style="display: flex;justify-content: center;">
                        <div style=" width:5vw; text-align: end;">
                            <p class="footer-count">{data.i}</p>
                        </div>
                        <div style="margin-left: 7.808vw;">
                            <p class="footer-text">
                                {data.description}
                            </p>
                        </div>
                    </div>
                {/each}
            </div>
            <div style="text-align: center;margin-top:12vw;">
                <button
                    on:click={() => (location.href = '/applyProgram')}
                    style="padding: 2vw 11vw; border-radius:8.333vw;border:none;background-color:#F7E05F;font-size:3.611vw;"
                    >Apply</button
                >
            </div>
        </div>
        <div style="position: relative; height: 130vw;">
            <div style="position: relative; margin-top: -4.3vw;">
                <div class="circle_mbl" />
                <div class="circle_mbl" />
                <div class="circle_mbl" />
            </div>
            <div
                style="display: flex;align-items:center; margin-left:5.833vw; margin-top: 8vw; margin-bottom: 5vw; "
            >
                <h1
                    class="section1"
                    style="color:#00204B;font-size:2.778vw;margin-right:5.833vw; opacity:0.3;"
                >
                    03
                </h1>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;margin-top:14vw;"
                >
                    Who else will be in this <br /> program or who will we
                    <br /> target for this program
                </h1>
            </div>
            <div>
                {#each pointsMbl as text}
                <div style="display: flex;
                align-items: center;
                margin: 9vw;
                padding-left: 13vw;
            ">
                    <div style="width: 3.334vw;
                    height: 3.334vw;
                    background: rgba(124, 193, 255, 1);
                    border-radius: 50%;
                 ">

                    </div>
                    <div
                    class="points"
                    style=""
                >
                    <h5 style="margin: 0;">{@html text.description}</h5>
                </div>
                </div>
                    
                {/each}
            </div>
        </div>
        <div
            style="display: flex;
            align-items: center;
            margin-left: 5.833vw;
            margin-top: 39.201vw;
            margin-bottom: 5vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:5.833vw; opacity:0.3;"
            >
                04
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;text-align: center;"
            >
                Benefits of this Program
            </h1>
        </div>
        <div>
            {#each benefitsMbl as data}
                <div
                    class="invesment-div-mbl"
                    style="background-color: {data.bg_color};"
                >
                    <hr class="hr-css-mbl" />

                    <p
                        style="font-size: 3.611vw; font-weight:400; padding: 12vw 5vw; color:white; "
                    >
                        {data.text}
                    </p>
                </div>
            {/each}
        </div>
        <div
            style="display: flex;align-items:center; margin-left:1vw; margin-top: 10vw;
            margin-bottom: 5vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-left:5.833vw; opacity:0.3; margin-top: -30vw;"
            >
                05
            </h1>
            <div>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;margin-top: 8vw; margin-left:4vw;"
                >
                    Application or Custom <br /> Design Process
                </h1>
                <div style="width:70vw; margin:2vw 0vw 0vw 4vw">
                    <p style="font-size:3.056vw; text-align: justify;">
                        Our large global network and experience in Venture
                        Capital helps us design programs with Governments that
                        can accelerate the process of reaching economic goals,
                        increase job creation and provide tremendous
                        opportunities for the next generation.
                    </p>
                </div>
            </div>
        </div>
        <div class="process-div-mbl">
            <h4
                style="font-size:5.556vw; font-weight:600; color:#00204B;padding: 4.5vw 27vw 2.5vw 27vw;"
            >
                Process
            </h4>
            <ul class="process_mbl">
                {#each processText as data}
                    <li style="">
                        <p
                            style="width: 60vw;padding-left: 1vw;font-size: 4vw;line-height:5vw;margin-top:4vw;"
                        >
                            {data.text}
                        </p>
                    </li>
                {/each}
            </ul>
        </div>
        <div
            style="display: flex;align-items:center; margin-left:5.833vw; margin-top: 15vw; margin-bottom: 5vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:5.833vw; opacity:0.3;"
            >
                06
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600;text-align: center;"
            >
                Faqs
            </h1>
        </div>
        <div
            class={usermbl.view_all_mbl ? 'view-all_mbl' : 'view-less_mbl'}
            style="overflow: hidden;"
        >
            <FaqMbl detailMbl={faqGlobal} />
        </div>
        {#if !usermbl.view_all_mbl}
            <button class="view-all-btn_mbl " on:click={toggleMbl}>
                <p class="view-text_mbl ">Load More</p>
                <div style="width: 1.5vw;margin-left: 1.98vw;">
                    <img
                        src="images/global_section/arrow.svg"
                        alt=""
                        width="100%"
                    />
                </div>
            </button>
        {/if}
        {#if usermbl.view_all_mbl}
            <button class="view-all-btn_mbl  " on:click={toggleMbl}>
                <p class="view-text_mbl ">Load Less</p>
                <div
                    style="width: 1.5vw;margin-left: 1.98vw;;transform: rotate(180deg);"
                >
                    <img
                        src="images/global_section/arrow.svg"
                        alt=""
                        width="100%"
                    />
                </div>
            </button>
        {/if}
        <div
            style="display: flex;align-items:center; margin-left:5.833vw; margin-top: 16vw;
            margin-bottom: 5vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:5.833vw; opacity:0.3;"
            >
                07
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;"
            >
                Alumni Success Stories
            </h1>
        </div>
        <SliderRightMbl sliderRight={sliderRightMbl} />
        <SliderLeftMbl sliderLeft={sliderLeftMbl} />
        <div
            style="display: flex;align-items:center; margin-left:5.833vw; margin-top: 10vw;
            margin-bottom: 5vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:5.833vw; opacity:0.3;"
            >
                08
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;"
            >
                Curriculum Highlights
            </h1>
        </div>
        <div
            style="border-radius:3vw;box-shadow: 0vw 0.265vw 2.912vw rgba(0, 32, 75, 0.2);width: 90vw;
        margin: 6vw auto; height:126vw;"
        >
            {#each curriculum as data}
                <div class="content-holder_mbl">
                    <div style="padding: 5vw 3vw">
                        <div
                            class="img-wrraper-logo"
                            style="width:{data.mbl_width};
                            margin-left:5vw;"
                        >
                            <img src={data.img} alt="" width="100%" />
                        </div>
                        <div>
                            <h1
                                class="section1list"
                                style="font-size:3.056vw ;width: 78.056vw; line-height:3.697vw;
                                margin: 6vw 5vw;"
                            >
                                {data.description}
                            </h1>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
        <div
            style="display: flex;align-items:center; margin-left:5.833vw; margin-top: 10vw;
            margin-bottom: 5vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:5.833vw; opacity:0.3;"
            >
                09
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;"
            >
                PARTNER HIGHLIGHTS
            </h1>
        </div>
        <div style="width: 73.722vw; margin: 2vw 0vw 0vw 15vw;">
            <p style="font-size:3.056vw; text-align: justify;">
                Our alumni hail from 101 countries and we work with numerous
                government policy makers, ministries and institutional partners
                in developing ecosystems. We collaborate to work towards
                building entrepreneurship support systems, job creation,
                empowering youth and building foundations for future technology.
                All our partnerships focus on building sustainable, scalable and
                long term impact.
            </p>
        </div>
        <div
            style="
        margin-left: 5.556vw;
        width: 89.998vw;
    "
        >
            <img src="images/global_section/partners.svg" alt="" width="100%" />
        </div>
    </div>

    <div style="position:relative; margin-top: 7.569vw;">
        <Footer />
    </div>
</section>

<style>
    .footer-count {
        font-weight: bold;
        font-size: 1.7vw;
        font-family: "inter";
        color: #88bce5;
    }
    .footer-text {
        font-size: 1.323vw;
        margin-bottom: 0vw;
        font-weight: 500;
        font-family: "inter";
        width: 30.86vw;
        margin-top: 0.75vw;
        color: white;
    }
    section {
        font-family: "inter";
    }
    /* ol li::marker {
        color: #7cc1ff;
        font-size: 1.5vw;
    } */
    .circle {
        height: 24.802vw;
        width: 24.802vw;
        border-radius: 50%;
        opacity: 40%;
        position: absolute;
        left: -14.286vw;
        background-color: rgba(60, 136, 195, 0.33);
        justify-content: center;
    }
    .circle:nth-child(2) {
        top: 10.78vw;
    }
    .circle:nth-child(3) {
        top: 21.23vw;
    }
    .circle_mbl {
        height: 50.556vw;
        width: 50.556vw;
        border-radius: 50%;
        opacity: 40%;
        position: absolute;
        left: -35vw;
        top: 30vw;
        background-color: rgba(60, 136, 195, 0.33);
        justify-content: center;
    }
    .circle_mbl:nth-child(2) {
        top: 72vw;
    }
    .circle_mbl:nth-child(3) {
        top: 50vw;
    }
    ul li::marker {
        color: #7cc1ff;
        font-size: 1.5vw;
    }
    .invesment-div {
        position: relative;
        width: 25.794vw;
        height: 13.889vw;
        border-radius: 1.323vw;

        margin-top: 0.5vw;
    }
    .hr-css {
        width: 25.794vw;
        color: #f7e05f;
        margin-top: 1.3vw;
        opacity: 1;
        position: absolute;
        border: 0.198vw solid;
    }
    .invesment-div-mbl {
        position: relative;
        width: 79.444vw;
        height: 31.944vw;
        border-radius: 5.556vw;
        margin: auto;
        margin-top: 3.5vw;
    }
    .hr-css-mbl {
        width: 79.5vw;
        top: 1vw;
        color: #f7e05f;
        opacity: 1;
        position: absolute;
        border: 0.498vw solid;
        border-radius: 0.7vw 0.7vw 0vw 0vw;
    }
    .process-div {
        width: 41.204vw;
        height: 24.735vw;
        box-shadow: 0px -1.124vw 1.323vw rgb(60 116 192 / 20%);
        border-radius: 2vw;
        margin-left: 46.495vw;
        margin-top: 4.762vw;
    }
    .points {
        padding-left: 6vw;
        position: relative;
    }
    .content-holder:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .content-holder:nth-child(1) {
        border-top-left-radius: 1vw;
        border-top-right-radius: 1vw;
    }
    .content-holder_mbl:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .content-holder_mbl:nth-child(1) {
        border-top-left-radius: 3vw;
        border-top-right-radius: 3vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        /* ol li::marker {
            font-size: 4.5vw !important;
        } */
        .footer-count {
            font-weight: bold;
            font-size: 5.556vw;
            font-family: "inter";
            color: #88bce5;
        }
        .footer-text {
            font-size: 3.056vw;
            font-weight: 500;
            font-family: "inter";
            width: 69vw;
            margin-top: 1vw;
            line-height: 5.556vw;
            color: white;
            margin-bottom: 9.009vw;
        }
    }
    .process-div-mbl {
        width: 76.111vw;
        height: 85vw;
        background-color: white;
        border-radius: 7vw 7vw 0vw 0vw;
        box-shadow: 0px -9px 20px rgba(60, 116, 192, 0.2);
        margin: auto;
        margin-top: 10vw;
    }
    .process_mbl li::marker {
        color: #7cc1ff;
        font-size: 4.19vw;
    }
    .view-all-btn {
        display: flex;
        border: none;
        background-color: transparent;
        margin: auto;
        margin-top: 2vw;
    }
    .view-all {
        height: 83vw;
        margin-bottom: 4.299vw;
    }
    .view-less {
        max-height: 49vw;
        min-height: auto;
        margin-bottom: 4.299vw;
    }
    .view-text {
        color: #00204b;
        font-size: 0.921vw;
        font-weight: 600;
        margin-bottom: 0;
    }
    .view-all-btn_mbl {
        display: flex;
        border: none;
        background-color: transparent;
        margin: auto;
        margin-top: 2vw;
    }

    .view-text_mbl {
        color: #00204b;
        font-size: 3.056vw;
        font-weight: 600;
        margin-bottom: 0;
    }
    .view-all_mbl {
        height: 277vw;
    }
    .view-less_mbl {
        height: 163vw;
    }
    /* .corner-left {
        width: 8.611vw;
        height: 8.611vw;
        position: absolute;
        border: 1.389vw solid #7cc1ff;
        border-bottom: none;
        border-right: none;
        left: 4.278vw;
        top: -6vw;
    }
    .corner-right {
        width: 8.611vw;
        height: 8.611vw;
        position: absolute;
        border: 1.389vw solid #7cc1ff;
        border-top: none;
        border-left: none;
        right: 4.278vw;
        bottom: 3vw;
    }
    .social-icon {
        display: flex;
        width: 72.751vw;
        height: 10vw;
        justify-content: space-between;
        margin-left: 13.624vw;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 8vw;
    } */
    /* .points::after {
        content: "";
        width: 3.334vw;
        height: 3.334vw;
        border-radius: 50%;
        background-color: rgba(124, 193, 255, 1);
        position: absolute;
        left: 20vw;
        top: 2vw;
    } */
</style>
